import {
  addDays,
  addMonths,
  endOfDay,
  endOfMonth,
  isSameDay,
  set,
  startOfDay,
  startOfMonth,
} from 'date-fns'
import { endOfWeekLocale, startOfWeekLocale } from 'utils/dateFns/weekdays'

const createPresets = () => {
  const today = set(new Date(), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  })

  return {
    startOfWeek: startOfWeekLocale(today),
    endOfWeek: today,
    startOfLastWeek: startOfWeekLocale(addDays(today, -7)),
    endOfLastWeek: endOfWeekLocale(addDays(today, -7)),
    startOfToday: startOfDay(today),
    // startOfLastSevenDay: startOfDay(addDays(today, -7)),
    // startOfLastThirtyDay: startOfDay(addDays(today, -30)),
    // startOfLastNintyDay: startOfDay(addDays(today, -90)),
    endOfToday: endOfDay(today),
    startOfYesterday: startOfDay(addDays(today, -1)),
    endOfYesterday: endOfDay(addDays(today, -1)),
    startOfMonth: startOfMonth(today),
    endOfMonth: today,
    startOfLastMonth: startOfMonth(addMonths(today, -1)),
    endOfLastMonth: endOfMonth(addMonths(today, -1)),
    lastThirtyDays: endOfDay(addDays(today, -29)),
    // startOfYear: startOfYear(today),
    // endOfYear: endOfYear(today),
    // startOflastYear: startOfYear(addYears(today, -1)),
    // endOflastYear: endOfYear(addYears(today, -1))
  }
}

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range()
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    )
  },
}

export function createStaticRanges(ranges) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }))
}

export const defaultStaticRanges = (t, i18n) => {
  const presets = createPresets(i18n)

  return createStaticRanges([
    {
      label: t('common::date_presets.today'),
      range: () => ({
        preset_name: 'today',
        startDate: presets.startOfToday,
        endDate: presets.endOfToday,
      }),
    },
    {
      label: t('common::date_presets.yesterday'),
      range: () => ({
        preset_name: 'yesterday',
        startDate: presets.startOfYesterday,
        endDate: presets.endOfYesterday,
      }),
    },

    {
      label: t('common::date_presets.this_week'),
      range: () => ({
        preset_name: 'this_week',
        startDate: presets.startOfWeek,
        endDate: presets.endOfWeek,
      }),
    },
    {
      label: t('common::date_presets.last_week'),
      range: () => ({
        preset_name: 'last_week',
        startDate: presets.startOfLastWeek,
        endDate: presets.endOfLastWeek,
      }),
    },
    {
      label: t('common::date_presets.this_month'),
      range: () => ({
        preset_name: 'this_month',
        startDate: presets.startOfMonth,
        endDate: presets.endOfMonth,
      }),
    },
    {
      label: t('common::date_presets.last_month'),
      range: () => ({
        preset_name: 'last_month',
        startDate: presets.startOfLastMonth,
        endDate: presets.endOfLastMonth,
      }),
    },
    {
      label: t('common::date_presets.last_thirty_days'),
      range: () => ({
        preset_name: 'last_thirty_days',
        startDate: presets.lastThirtyDays,
        endDate: presets.endOfToday,
      }),
    },
  ])
}
